import { useState, useEffect } from "react"
import axios from "axios"

export const useGetLyrics = (artist, title) => {
  const [lyrics, setLyrics] = useState()

  useEffect(() => {
    axios
      .get(`https://cosmox-back.herokuapp.com/lyrics/?artist=${artist}&track=${title}`)
      .then(res => {
        setLyrics(res.data.lyrics)
      })
      .catch((err) => {
        //window.location = "/"
      })
  }, [artist, title]) // eslint-disable-line react-hooks/exhaustive-deps

  return {lyrics}
}
